import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-interceptor',
  standalone: true,
  imports: [],
  templateUrl: './user-interceptor.component.html',
  styleUrl: './user-interceptor.component.css'
})
export class UserInterceptorComponent implements HttpInterceptor{
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const userId = localStorage.getItem("user_id");
    if (userId &&  !request.url.includes('authentication/save_token')) 
    {
      // Clone the request and add user_id to the payload
         let modifiedRequest;
        if (request.body instanceof FormData) {
          modifiedRequest =  request.clone({
            body:  request.body.append("user_id", userId)
          })
        } 
        else if (request.url.includes('add/')) {
          modifiedRequest =  request.clone({
            body: {
            ...JSON.parse(request.body),
            user_id: userId,
          }
        })
        } 
        else{
          modifiedRequest =  request.clone({
            body: {
            ...request.body,
            user_id: userId,
          }
        })
        } 
      // Pass the modified request to the next handler
      return next.handle(modifiedRequest);
    }

    // If user_id is not available, proceed with the original request
    return next.handle(request);
  }
}
